import React, { useState, useEffect, useRef } from "react";
import logo from "../../assets/images/aammi-logo.webp";
import playstore from "../../assets/images/play_store_logo.png";
import appstore from "../../assets/images/apple_store_logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faHeart } from "@fortawesome/free-regular-svg-icons";
import { NavLink } from "react-router-dom";
import {
  faBars,
  faCartShopping,
  faMagnifyingGlass,
  faCube,
  faRightFromBracket,
  faRecycle,
  faXmark,
  faAngleDown,
  faRightToBracket,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";

import { Link, useNavigate } from "react-router-dom";
import Usericon from "../../assets/new-images/user-icon.png";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import "./Header.css";
import { apiurl } from "../../Constants";
import { useSelector, useDispatch } from "react-redux";
import { fetchCartItems } from "../../features/cartitemsSlice";
import { Dropdown } from "bootstrap";
const Header = () => {
  const [activeDropdown, setActiveDropdown] = useState(0);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const navigation = useNavigate("");

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [activeTab, setActiveTab] = useState(0);

  const { items = [] } = useSelector((state) => state.cartitems);

  const [cartItems, setCartItems] = useState(items);

  const dispatch = useDispatch();

  const user_id = localStorage.getItem("userId");

  useEffect(() => {
    if (user_id) {
      dispatch(fetchCartItems(user_id));
    }
  }, [dispatch, user_id]);

  useEffect(() => {
    setCartItems(items.map((item) => ({ ...item })));
  }, [items]);

  const toggleMenu = () => {
    console.log("ggg");
    setIsMenuOpen(!isMenuOpen);
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const [menuheading, setMenuheading] = useState([]);

  const [fetchmenulist, setFetchmenulist] = useState(false);

  useEffect(() => {
    const fetchdata = async () => {
      await axios
        .get(apiurl + "menu_list")
        .then((res) => {
          setMenuheading(res.data.data);
          const categories = res.data.data.map((item) => item.category_name);
          setPlaceholderTexts(categories);
          setFetchmenulist(true);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    if (!fetchmenulist) {
      fetchdata();
    }
  }, [fetchmenulist]);

  const handleMouseEnter = (index) => {
    setActiveDropdown(index);
    setIsDropdownVisible(true);
  };

  const handleMouseEnters = () => {
    setActiveDropdown("allcategories");
    setIsDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    if (!isDropdownVisible) {
      setIsDropdownVisible(false);
      setActiveDropdown(null);
    }
  };

  const handleDropdownMouseEnter = () => {
    setIsDropdownVisible(true);
  };

  const handleDropdownMouseLeave = () => {
    setIsDropdownVisible(false);
    setActiveDropdown(null);
  };

  const [placeholderTexts, setPlaceholderTexts] = useState([]);
  const [placeholder, setPlaceholder] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [typingIndex, setTypingIndex] = useState(0);

  const username = localStorage.getItem("userName");
  const userid = localStorage.getItem("userId");

  useEffect(() => {
    if (placeholderTexts.length === 0) return;

    const currentPlaceholder = placeholderTexts[currentIndex];
    if (typingIndex < currentPlaceholder.length) {
      const typingTimeout = setTimeout(() => {
        setPlaceholder((prev) => prev + currentPlaceholder[typingIndex]);
        setTypingIndex(typingIndex + 1);
      }, 100);

      return () => clearTimeout(typingTimeout);
    } else {
      const nextTextTimeout = setTimeout(() => {
        setCurrentIndex((currentIndex + 1) % placeholderTexts.length);
        setPlaceholder("");
        setTypingIndex(0);
      }, 2000);

      return () => clearTimeout(nextTextTimeout);
    }
  }, [typingIndex, currentIndex, placeholderTexts]);

  const logoutClick = () => {
    localStorage.removeItem("userName");
    localStorage.removeItem("userId");
    navigation("/");
    window.location.reload();
  };

  const [openMenus, setOpenMenus] = useState(null);
  const [openSubMenus, setOpenSubMenus] = useState(null);

  const toggleMenus = (menuId) => {
    setOpenMenus((prevState) => (prevState === menuId ? null : menuId));
  };

  const toggleSubMenus = (subId) => {
    setOpenSubMenus((prevState) => (prevState === subId ? null : subId));
  };

  const findSubcategoryPath = (subcategorySlug) => {
    for (const cat of menuheading) {
      for (const sub of cat.subcategory || []) {
        if (sub.subcategory_slug === subcategorySlug) {
          return {
            category_slug: cat.category_slug,
            subcategory_slug: sub.subcategory_slug,
          };
        }
      }
    }
    return null;
  };

  const findSubChildPath = (subchildSlug) => {
    for (const cat of menuheading) {
      for (const sub of cat.subcategory || []) {
        for (const child of sub.subchildcategory || []) {
          if (child.subchild_slug === subchildSlug) {
            return {
              category_slug: cat.category_slug,
              subcategory_slug: sub.subcategory_slug,
              subchild_slug: child.subchild_slug,
            };
          }
        }
      }
    }
    return null;
  };

  const [searchKeyword, setSearchKeyword] = useState("");

  const [searchResults, setSearchResults] = useState({
    product: [],
    category: [],
    subcategory: [],
    subchildcategory: [],
  });

const [isDropdownVisibles, setIsDropdownVisibles] = useState(false);
const searchBoxRef = useRef(null);
const mobileSearchBoxRef = useRef(null);

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (!searchKeyword || menuheading.length === 0) {
        setIsDropdownVisibles(false);
        return;
      }

      try {
        const response = await axios.post(apiurl + "search_key_word", {
          key_word: searchKeyword,
        });

        const data = response.data.search_key_word;

        const normalizedSubcategories = (data.subcategory || [])
          .map((item) => {
            const path = findSubcategoryPath(item.slug);
            return path ? { ...item, ...path } : null;
          })
          .filter(Boolean);

        const normalizedSubChild = (data.subchildcategory || [])
          .map((item) => {
            const path = findSubChildPath(item.slug);
            return path ? { ...item, ...path } : null;
          })
          .filter(Boolean);

        setSearchResults({
          ...data,
          subcategory: normalizedSubcategories,
          subchildcategory: normalizedSubChild,
        });

        setIsDropdownVisibles(true);
      } catch (err) {
        console.error(err);
      }
    };
    fetchSearchResults();
  }, [searchKeyword, menuheading]);

   useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideDesktop =
        !searchBoxRef.current || !searchBoxRef.current.contains(event.target);
      const isOutsideMobile =
        !mobileSearchBoxRef.current ||
        !mobileSearchBoxRef.current.contains(event.target);

      if (isOutsideDesktop && isOutsideMobile) {
        setSearchKeyword("");
        setIsDropdownVisibles(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  return (
    <>
      <div className="upper-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="inner-box-main">
                <div className="logo-box" style={{ width: "6%" }}>
                  <NavLink to="/">
                    <img src={logo} style={{ cursor: "pointer" }} alt="logo" />
                  </NavLink>
                </div>

                <div ref={searchBoxRef} className="search-box">
                     <div className="search-box-inner-box">
                    <input
                      type="text"
                      placeholder={"Search " + placeholder}
                      value={searchKeyword}
                      style={{ fontSize: "12px" }}
                      onChange={(e) => setSearchKeyword(e.target.value)}
                    />
                    {searchKeyword && (
                      <span
                        className="search-close-icon"
                        onClick={() => {
                          setSearchKeyword("");
                          setIsDropdownVisibles(false);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </span>
                    )}
                    <span className="search-icon">
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </span>
                  </div>

                  {isDropdownVisibles && (
                    <div className="search_box_list">
                      {searchKeyword && (
                        <div className="search-results">
                          <ul>
                            {searchResults.product &&
                              searchResults.product.length > 0 && (
                                <>
                                  {searchResults.product.map((product) => (
                                    <li key={product.product_id}>
                                      <Link
                                        to={`/product-details/${product.slug}`}
                                        style={{ display: "block" }}
                                        onClick={() => {
                                          setSearchKeyword(
                                            product.product_name
                                          );
                                          setIsDropdownVisibles(false); // Close the dropdown
                                        }}
                                      >
                                        {product.product_name}
                                      </Link>
                                    </li>
                                  ))}
                                </>
                              )}
                              
                            {searchResults.category &&
                              searchResults.category.length > 0 && (
                                <>
                                  {searchResults.category.map((category) => (
                                    <li key={category.category_id}>
                                      <Link
                                        to={`/${category.slug}`}
                                        onClick={() => {
                                          setSearchKeyword(
                                            category.category_name
                                          );
                                          setIsDropdownVisibles(false);
                                        }}
                                      >
                                        {category.category_name}
                                      </Link>
                                    </li>
                                  ))}
                                </>
                              )}
                            {searchResults.subcategory &&
                              searchResults.subcategory.length > 0 && (
                                <>
                                  {searchResults.subcategory.map(
                                    (subcategory) => (
                                      <li key={subcategory.subcategory_id}>
                                        <Link
                                          to={`/${subcategory.category_slug}/${subcategory.subcategory_slug}`}
                                          onClick={() => {
                                            setSearchKeyword(
                                              subcategory.subcategory_name
                                            );
                                            setIsDropdownVisibles(false);
                                          }}
                                        >
                                          {subcategory.subcategory_name}
                                        </Link>
                                      </li>
                                    )
                                  )}
                                </>
                              )}
                            {searchResults.subchildcategory &&
                              searchResults.subchildcategory.length > 0 && (
                                <>
                                  {searchResults.subchildcategory.map(
                                    (subchildcategory) => (
                                      <li
                                        key={
                                          subchildcategory.subchildcategory_id
                                        }
                                      >
                                        <Link
                                          to={`/${subchildcategory.category_slug}/${subchildcategory.subcategory_slug}/${subchildcategory.subchild_slug}`}
                                        >
                                          {
                                            subchildcategory.subchildcategoryname
                                          }
                                        </Link>
                                      </li>
                                    )
                                  )}
                                </>
                              )}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="account-profile">
                  <Link to="/account" style={{ textDecoration: "none" }}>
                    <div className="inner-box">
                      <div className="icon-box">
                        <img src={Usericon} alt="user icon" />
                      </div>

                      {userid ? (
                        <div className="label-box">
                          <p>Welcome,</p>
                          <h5>{username}</h5>
                        </div>
                      ) : null}
                    </div>
                  </Link>

                  <div className="dropdown_main_box">
                    {!userid && (
                      <div className="msg_box">
                        <span>New Customer ?</span>
                        <Link to="/register">Sign in</Link>
                      </div>
                    )}
                    <ul>
                      {!userid && (
                        <li>
                          <Link to="/login">
                            <FontAwesomeIcon icon={faRightToBracket} />
                            Login
                          </Link>
                        </li>
                      )}
                      {!userid && (
                        <li>
                          <Link to="/register">
                            <FontAwesomeIcon icon={faPencil} />
                            Register
                          </Link>
                        </li>
                      )}
                      {userid && (
                        <li>
                          <Link to="/account">
                            <FontAwesomeIcon icon={faUser} />
                            My Profile
                          </Link>
                        </li>
                      )}
                      {/* {userid && (
                        <li>
                          <Link to="">
                            <FontAwesomeIcon icon={faCube} />
                            Orders
                          </Link>
                        </li>
                      )} */}

                      {userid && (
                        <li>
                          <Link to="/wishlist">
                            <FontAwesomeIcon icon={faHeart} />
                            Wishlist
                          </Link>
                        </li>
                      )}

                      {userid && (
                        <li>
                          <Link onClick={logoutClick}>
                            <FontAwesomeIcon icon={faRightFromBracket} />
                            Logout
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <div className="icons_header">
                  <div className="icon_box">
                    <ul>
                      <li>
                        <Link to="/wishlist">
                          <FontAwesomeIcon icon={faHeart} />
                        </Link>
                      </li>
                      <li>
                        <div className="cart-icon">
                          <Link to="/cart">
                            <FontAwesomeIcon icon={faCartShopping} />
                          </Link>

                          {/* Determine cart count from either state or sessionStorage */}
                          {(() => {
                            let count = 0;

                            if (userid && items.length > 0) {
                              count = items.length;
                            } else {
                              const tempCart =
                                sessionStorage.getItem("temp_cart");
                              try {
                                const parsedCart = JSON.parse(tempCart);
                                if (Array.isArray(parsedCart)) {
                                  count = parsedCart.length;
                                }
                              } catch (e) {
                                console.error(
                                  "Invalid sessionStorage cart data",
                                  e
                                );
                              }
                            }

                            return count > 0 ? (
                              <sup className="badge_icon">{count}</sup>
                            ) : null;
                          })()}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="download-app">
                  <div className="inner-box">
                    <img
                      src={playstore}
                      style={{ width: "auto" }}
                      alt="Play Store"
                    />
                    <img
                      src={appstore}
                      style={{ width: "auto" }}
                      alt="App Store"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="middle_header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 left_col">
              <div className="menu_list_inner_box">
                <ul>
                  {menuheading && menuheading.length > 0
                    ? menuheading.slice(0, 9).map((item, index) => {
                        return (
                          <li
                            key={index}
                            onMouseEnter={() => handleMouseEnter(index)}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => setActiveDropdown(null)}
                          >
                            <Link
                              to={`/${item.category_slug}`}
                              state={{ categoryId: item.id }}
                              className="menu-link"
                            >
                              {item.category_name}
                            </Link>
                          </li>
                        );
                      })
                    : null}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container dropdown-container"
        style={{ backgroundColor: "#fff" }}
      >
        <div>
          {isDropdownVisible && (
            <div
              className="dropdown-box"
              onMouseEnter={handleDropdownMouseEnter}
              onMouseLeave={handleDropdownMouseLeave}
            >
              {activeDropdown >= 0 && (
                <>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="inner_box">
                        <div className="row">
                          <div className="col-9">
                            <div className="tab_content_sub_heading">
                              {menuheading[activeDropdown] && (
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  {menuheading[
                                    activeDropdown
                                  ]?.subcategory?.map(
                                    (subcategories, childindex) => (
                                      <div
                                        key={childindex}
                                        className="child-item"
                                      >
                                        <Link
                                          style={{ textDecoration: "none" }}
                                          to={`/${menuheading[activeDropdown]?.category_slug}/${subcategories?.subcategory_slug}`}
                                          state={{ subcategoryId: subcategories?.id }}
                                          onClick={() =>
                                            setActiveDropdown(null)
                                          }
                                        >
                                          <h6>
                                            {subcategories?.subcategory_name}
                                          </h6>
                                        </Link>

                                        <ul>
                                          {subcategories?.subchildcategory?.map(
                                            (subChild, subChildIndex) => (
                                              <li key={subChildIndex}>
                                                <Link
                                                  to={`/${menuheading[activeDropdown]?.category_slug}/${subcategories?.subcategory_slug}/${subChild?.subchild_slug}`}
                                                  state={{ subchildId: subChild?.id }}
                                                  onClick={() =>
                                                    setActiveDropdown(null)
                                                  }
                                                >
                                                  {
                                                    subChild?.subchildcategoryname
                                                  }
                                                </Link>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                     <div className="col-3 p-5">
  <div>
    <Link
      to={`/${menuheading[activeDropdown]?.category_slug}`}
      state={{ categoryId: menuheading[activeDropdown]?.id }}
      style={{ textDecoration: "none" }}
    >
      <div>
        {menuheading[activeDropdown]?.category_img ? (
          <img
            src={menuheading[activeDropdown]?.category_img}
            alt={menuheading[activeDropdown]?.category_name}
          />
        ) : null}
      </div>
      {menuheading[activeDropdown]?.category_name ? (
        <h6 className="text-center" style={{ color: "#000" }}>
          {menuheading[activeDropdown]?.category_name.slice(0, 20)}
        </h6>
      ) : null}
    </Link>
  </div>
</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="mobile_header">
        <div className="container">
          <div className="main_row">
            <div className="logo_col">
              <div className="logo_box">
                <Link to="/">
                  <img src={logo} alt="Logo" />
                </Link>
              </div>
            </div>
            <div className="icons_col">
              <ul>
                <li className="mobile_usersprofile">
                  <Link>
                    <FontAwesomeIcon icon={faUser} />
                  </Link>
                  <ul className="mobile_usersprofile_list">
                    {!userid && (
                      <li>
                        <FontAwesomeIcon icon={faRightToBracket} />
                        <Link to="/login">&nbsp;&nbsp; Login</Link>
                      </li>
                    )}
                    {!userid && (
                      <li>
                        <FontAwesomeIcon icon={faPencil} />
                        <Link to="/register">&nbsp;&nbsp; Register</Link>
                      </li>
                    )}
                    {userid && (
                      <li>
                        <FontAwesomeIcon icon={faUser} />
                        <Link to="/account">&nbsp;&nbsp; My Profile</Link>
                      </li>
                    )}

                    {userid && (
                      <li>
                        <FontAwesomeIcon icon={faHeart} />
                        <Link to="/wishlist">&nbsp;&nbsp; Wishlist</Link>
                      </li>
                    )}

                    {userid && (
                      <li>
                        <FontAwesomeIcon icon={faRightFromBracket} />
                        <Link onClick={logoutClick}>&nbsp;&nbsp; Logout</Link>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  <Link to="/wishlist">
                    <FontAwesomeIcon icon={faHeart} />
                  </Link>
                </li>
                <li>
                  <div className="cart-icon">
                    <Link to="/cart">
                      <FontAwesomeIcon icon={faCartShopping} />
                    </Link>
                    {userid && items.length > 0 ? (
                      <sup className="badge_icon">
                        {items.length ? items.length : null}
                      </sup>
                    ) : null}
                  </div>
                </li>

                <li>
                  <FontAwesomeIcon icon={faBars} onClick={toggleMenu} />
                </li>
              </ul>
            </div>
          </div>

         <div ref={mobileSearchBoxRef} className="search-box">
            <div className="search-box-inner-box">
              <input
                type="text"
                placeholder={"Search " + placeholder}
                value={searchKeyword}
                style={{ fontSize: "12px" }}
                onChange={(e) => setSearchKeyword(e.target.value)}
              />

              {searchKeyword && (
                <span
                  className="search-close-icon"
                  onClick={() => {
                    setSearchKeyword("");
                    setIsDropdownVisibles(false);
                  }}
                >
                  <FontAwesomeIcon icon={faXmark} />
                </span>
              )}

              <span className="search-icon">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </span>
            </div>

            {isDropdownVisibles && (
              <div className="search_box_list">
                {searchKeyword && (
                  <div className="search-results">
                    <ul>
                      {searchResults.product &&
                        searchResults.product.length > 0 && (
                          <>
                            {searchResults.product.map((product) => (
                              <li key={product.product_id}>
                                  <Link
                                    to={`/product-details/${product.slug}`}
                                    onClick={() => {
                                      setSearchKeyword(product.product_name);
                                      setIsDropdownVisibles(false); // Close the dropdown
                                    }}
                                >
                                  {product.product_name}
                                </Link>
                              </li>
                            ))}
                          </>
                        )}
                      {searchResults.category &&
                        searchResults.category.length > 0 && (
                          <>
                            {searchResults.category.map((category) => (
                              <li key={category.category_id}>
                                  <Link
                                    to={`/${category.slug}`}
                                    onClick={() => {
                                      setSearchKeyword(category.category_name);
                                      setIsDropdownVisibles(false);
                                    }}
                                >
                                  {category.category_name}
                                </Link>
                              </li>
                            ))}
                          </>
                        )}
                      {searchResults.subcategory &&
                        searchResults.subcategory.length > 0 && (
                          <>
                            {searchResults.subcategory.map((subcategory) => (
                              <li key={subcategory.subcategory_id}>
                                  <Link
                                    to={`/${subcategory.category_slug}/${subcategory.subcategory_slug}`}
                                    onClick={() => {
                                      setSearchKeyword(
                                        subcategory.subcategory_name
                                      );
                                      setIsDropdownVisibles(false);
                                    }}
                                >
                                  {subcategory.subcategory_name}
                                </Link>
                              </li>
                            ))}
                          </>
                        )}
                      {searchResults.subchildcategory &&
                        searchResults.subchildcategory.length > 0 && (
                          <>
                            {searchResults.subchildcategory.map(
                              (subchildcategory) => (
                                <li key={subchildcategory.subchildcategory_id}>
                                  <Link
                                    to={`/${subchildcategory.category_slug}/${subchildcategory.subcategory_slug}/${subchildcategory.subchild_slug}`}
                                  >
                                    {subchildcategory.subchildcategoryname}
                                  </Link>
                                </li>
                              )
                            )}
                          </>
                        )}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>

          {isMenuOpen && (
            <div className="menu">
              <div className="menulogo_box">
                <img style={{ width: "12%" }} src={logo} alt="logo" />
                <FontAwesomeIcon onClick={toggleMenu} icon={faXmark} />
              </div>
              <ul>
                {menuheading.map((category) => (
                  <li key={category.id}>
                    <div className="main_category_main">
                      <Link
                        className="main_category"
                        to={`/${category.category_slug}`}
                        state={{ categoryId: category.id }}
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {category.category_name}
                      </Link>
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        onClick={() => toggleMenus(category.id)}
                      />
                    </div>

                    {openMenus === category.id && (
                      <ul className="sub_category_list">
                        {category.subcategory.map((sub) => (
                          <li key={sub.id}>
                            <div className="sub_category_main">
                              <Link
                                className="sub_category"
                                to={`/${category.category_slug}/${sub.subcategory_slug}`}
                                state={{ subcategoryId: sub.id }}
                                onClick={() => setIsMenuOpen(false)}
                              >
                                {sub.subcategory_name}
                              </Link>
                              <FontAwesomeIcon
                                icon={faAngleDown}
                                onClick={() => toggleSubMenus(sub.id)}
                              />
                            </div>
                            {openSubMenus === sub.id && (
                              <ul
                                className="sub_child_categorylist"
                                style={{
                                  display:
                                    openSubMenus === sub.id ? "block" : "none",
                                }}
                              >
                                {sub.subchildcategory.map((subChild) => (
                                  <li key={subChild.id}>
                                    <Link
                                      className="sub_child_category"
                                      to={`/${category.category_slug}/${sub.subcategory_slug}/${subChild.subchild_slug}`}
                                      state={{ subchildId: subChild.id }}
                                      onClick={() => setIsMenuOpen(false)}
                                    >
                                      {subChild.subchildcategoryname}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
              <ul>
                {!userid && (
                  <li>
                    <Link to="/login" onClick={() => setIsMenuOpen(false)}>
                      <FontAwesomeIcon icon={faUser} />
                      &nbsp;&nbsp; Login
                    </Link>
                  </li>
                )}
                {userid ? (
                  <li className="label-box">
                    <p style={{ display: "inline-block" }}>
                      Welcome, <h5 style={{ display: "inline" }}>{username}</h5>
                    </p>
                  </li>
                ) : null}
                {userid && (
                  <li>
                    <Link to="/account" onClick={() => setIsMenuOpen(false)}>
                      <FontAwesomeIcon icon={faUser} />
                      &nbsp;&nbsp; My Profile
                    </Link>
                  </li>
                )}

                {userid && (
                  <li>
                    <Link to="/wishlist" onClick={() => setIsMenuOpen(false)}>
                      <FontAwesomeIcon icon={faHeart} />
                      &nbsp;&nbsp; Wishlist
                    </Link>
                  </li>
                )}

                {userid && (
                  <li>
                    <Link onClick={logoutClick}>
                      <FontAwesomeIcon icon={faRightFromBracket} />
                      &nbsp;&nbsp; Logout
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          )}
          
        </div>
      </div>
    </>
  );
};

export default Header;
